module.exports = __webpack_public_path__ + "img/apexOpsLogo.2186ca27.svg";